var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"user-type":"supervisor"}}),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mt-16 px-6 mx-auto",attrs:{"md":"9","xl":"8"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }